import React, { useEffect } from "react";
import { MdMiscellaneousServices } from "react-icons/md";
import { Link } from "react-router-dom";
import { BsFillArrowUpRightCircleFill } from "react-icons/bs";

import welcomeimage from "../../assets/images/homescreen/welcomeimage.png";
import mpez from "../../assets/images/homescreen/mpez.jpg";

import evcharger from "../../assets/images/evcharger.png";
import electrical from "../../assets/images/electrical.jpeg";




import image29 from "../../assets/images/compressed/1000135783.png";
import image30 from "../../assets/images/compressed/1000135787.png";
import image39 from "../../assets/images/compressed/1000135823.png";
import image40 from "../../assets/images/compressed/1000135827.png";
import imgcontact from "../../assets/images/compressed/1000135771.png";


import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules"; // Correct import path for Swiper modules

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import Moving from "../../components/Movingimg/Moving";

import AOS from 'aos';
import 'aos/dist/aos.css';

import Ourleaders from "../../components/Ourleaders/Ourleaders";
import Countingnumber from "../../components/Counting/Countingnumber";

import Metatag from "../../components/Metatag/Metatag";
import Contacthome from "../../components/contacthome/contacthome";
import Timeline from "../../components/Timeline/Timeline";





const Home = () => {
  useEffect(() => {
    // Scroll to the top when the page loads
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    AOS.init({
      once: true,

    });
  }, []);

  const serviceData = [
    {
      id: "01",
      title: "Devotion to Quality",
      content: "We take pride in our unwavering commitment to quality, which is the foundation of our operations. Our rigorous quality management processes ensure that every product or service we deliver meets, and often exceeds, industry standards."
    },
    {
      id: "02",
      title: "Expert Workforce",
      content: "With vast industry experience, our team has honed their skills to expertly manage challenges and provide optimal solutions that exceed client expectations."
    },
    {
      id: "03",
      title: "Prompt Project Delivery",
      content: "Our team works tirelessly to ensure that every project is delivered on time without compromising on quality, thanks to efficient project management systems."
    },
    {
      id: "04",
      title: "Innovative Strategies",
      content: "We are committed to fostering innovation and creativity with cost-effective solutions. Our ability to adapt to the ever-changing market landscape ensures exceptional outcomes for our clients."
    }
  ];


  const swiperReq = require.context("../../assets/images/", false, /swiper.*\.(png|jpe?g|svg|webp)$/i);
  const slidesData = swiperReq.keys().map((key) => ({
    title: " Megavolt For DEWA Approved Electrical Service",
    subtitle: "Powering Innovation and Reliability",
    buttonLink: "/contactus",
    buttonText: "Discover Our Services",
    buttonColor: "bg-brand-gradient shadow-lg hover:shadow-primary/40 hover:scale-105 transition-all",
    imageSrc: swiperReq(key),
  }));

  const featuredReq = require.context("../../assets/images/featured/", false, /\.(png|jpe?g|svg|webp)$/i);
  const featuredImages = featuredReq.keys().map((key) => featuredReq(key));

  const mepServiceData = [
    {
      title: "DEWA APPROVALS",
      content: "As a trusted DEWA approval company in Dubai, we handle DEWA approvals, NOC submissions, electricity and water applications, fit-out connections, and network modification services with fast, accurate, and compliant support across the UAE.",
      link: "/contactus",
      image: mpez,
      alt: "DEWA approvals",
      icon: <BsFillArrowUpRightCircleFill />
    },
    {
      title: "EV CHARGER INSTALLATION",
      content: "As a trusted EV charger installation company in Dubai, Megavolt Technical Services Co. LLC delivers safe, compliant, and efficient EV charging solutions for homes, offices, villas, buildings, and commercial spaces.",
      link: "/contactus",
      image: evcharger,
      alt: "EV charger installation",
      icon: <BsFillArrowUpRightCircleFill />
    },
    {
      title: "ELECTRICAL WORKS",
      content: "As a trusted electrical contractor in Dubai, we provide complete electrical works including installation, maintenance, lighting, power systems, fit-out connections, and authority support with safe and efficient solutions across the UAE.",
      link: "/contactus",
      image: electrical,
      alt: "Electrical works",
      icon: <BsFillArrowUpRightCircleFill />
    },

  ];

  return (
    <div className="">
      <Metatag title="Dewa Approvals | Dewa Approved Contractor | Megavolt Tech - Dubai" description="Megavolt Team provides dewa approvals in dubai. Get in touch with our Dubai Approvals Team to apply fo r Electricity and water from our Dewa Appproval services" link="" />


      {/* main home banner */}
      <div className="">
        <Swiper
          pagination={{
            dynamicBullets: true,
          }}
          modules={[Pagination, Autoplay]}
          loop={true}
          autoplay={{
            delay: 1000,
            disableOnInteraction: false,
          }}
          speed={2000}
          className="mySwiper md:h-[85vh]"
        >
          {slidesData.map((slide, index) => (
            <SwiperSlide key={index}>

              <img src={slide.imageSrc} className="w-full object-cover h-[500px] md:h-auto" alt="itemImage" />
              <div className="absolute z-[999] text-white top-1/4 left-1/2 transform -translate-x-1/2 w-[90%] md:w-[50%]">
                <div className="flex flex-col justify-center items-center h-full">
                  <div className="lg:pl-8 p-3">
                    <h1 className="lg:text-4xl text-xl text-center font-bold">{slide.title}</h1>
                    <p className="text-xl text-center mt-4">{slide.subtitle}</p>
                    <div className="my-8 text-center">
                      <Link
                        to={slide.buttonLink}
                        className={`py-3 md:px-10 px-6 rounded-md ${slide.buttonColor} text-white uppercase inline-block`}
                      >
                        {slide.buttonText}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* our story */}

      <div className="container mx-auto space-y-6 p-4 md:space-y-16 md:py-16 overflow-hidden" >
        <div className="mb-5 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-8 lg:grid-cols-3">
          <div className="order-last flex flex-col justify-center p-4 md:order-first md:col-span-1 lg:col-span-2" data-aos="fade-right" data-aos-duration="1000">
            <h1 className="mb-4 text-2xl font-bold uppercase dark:text-[#dddddd] md:text-4xl">
              Overview of Megavolt
            </h1>
            <p className="text-sm md:text-base text-[#7a7a7a] text-justify leading-6">
              We specialize in providing comprehensive contracting services, electrical work, with a strong focus on obtaining . Our team  Megavolt of experts
              ensures that every project meets the strict standards and regulations set by the, making your construction and electrical processes seamless and efficient.
              Whether you need electrical
              installations for commercial or residential spaces. Specialists in DEWA & RTA Electrical Approvals and EV Charger Installations, our team ensures that every project complies with the strict standards and regulations set by DEWA, making your construction and electrical processes seamless and efficient.
              Let us handle the approval process while you focus on building your vision!
            </p>
            <div className=" mt-8">
              <Link to="/blog" className="py-3 px-10 rounded-md bg-brand-gradient text-white shadow-lg hover:shadow-primary/40 hover:scale-105 transition-all inline-block">Discover More</Link>
            </div>
          </div>
          <div className="group h-[300px]  bg-brand-gradient md:col-span-1 lg:col-span-1" data-aos="fade-left" data-aos-duration="1000">
            <div className="m-0 h-[300px] w-full duration-300 ease-in group-hover:m-0 xl:mb-[-25px] xl:ml-[25px] xl:mr-[-25px] xl:mt-[25px]">
              <img src={welcomeimage} alt="our story" className="h-[300px] w-full duration-300 ease-in" />
            </div>
          </div>

        </div>
      </div>

      {/* our service */}
      <div className="relative lg:py-24 py-16 px-4 bg-gradient-to-br from-[#f8fafc] to-[#e2e8f0] overflow-hidden">
        {/* Abstract background shapes for dynamic feel */}
        <div className="absolute top-0 right-0 -translate-y-12 translate-x-1/3 w-96 h-96 bg-primary rounded-full mix-blend-multiply filter blur-[128px] opacity-20 pointer-events-none"></div>
        <div className="absolute bottom-0 left-0 translate-y-1/3 -translate-x-1/3 w-96 h-96 bg-secondary rounded-full mix-blend-multiply filter blur-[128px] opacity-20 pointer-events-none"></div>

        <div className="container mx-auto relative z-10">
          <div className="text-center mb-16" data-aos="fade-down" data-aos-duration="1000">
            <span className="text-primary font-bold tracking-widest text-sm uppercase mb-3 block">Why Choose Us</span>
            <h1 className="font-extrabold text-3xl md:text-5xl text-[#090a0e] uppercase tracking-tight">Our Authorities</h1>
            <div className="w-20 h-1.5 bg-brand-gradient mx-auto mt-6 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            {serviceData.map((service, index) => (
              <div
                key={index}
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay={index * 150}
                className="group relative bg-white/80 backdrop-blur-xl border border-white/50 rounded-2xl p-8 hover:bg-white transition-all duration-500 ease-out hover:-translate-y-3 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgba(247,177,45,0.15)] overflow-hidden"
              >
                {/* Top thin line gradient that expands on hover */}
                <div className="absolute top-0 left-0 w-full h-1 bg-brand-gradient opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                {/* Big faint number in background */}
                <div className="absolute -bottom-6 -right-4 text-[140px] font-black text-gray-100 group-hover:text-primary/10 transition-all duration-500 select-none z-0 pointer-events-none transform group-hover:-translate-x-2 group-hover:-translate-y-2">
                  {service.id}
                </div>

                <div className="relative z-10">
                  <div className="w-16 h-16 bg-gray-50 rounded-2xl flex items-center justify-center mb-8 group-hover:bg-brand-gradient transition-all duration-500 shadow-sm border border-gray-100 group-hover:border-transparent group-hover:rotate-6">
                    <span className="text-2xl font-bold text-primary group-hover:text-white transition-colors duration-500">
                      {service.id}
                    </span>
                  </div>

                  <h3 className="text-xl font-bold text-[#090a0e] mb-4 group-hover:text-primary transition-colors duration-300">
                    {service.title}
                  </h3>

                  <p className="text-[#6b7280] leading-relaxed text-sm md:text-base group-hover:text-[#374151] transition-colors duration-300 text-left">
                    {service.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>


      {/* our contractors */}
      <div className="container mx-auto overflow-hidden " data-aos="fade-up" data-aos-duration='1300' >
        <div className="grid grid-cols-1 md:grid-cols-12 ">
          <div className="col-span-12 md:col-span-6 ">
            <div className="grid grid-cols-2 lg:pt-8 lg:gap-4 gap-4 p-3 justify-center">
              <div className="h-full sm:h-72">
                <img
                  src={image29}
                  alt="our story"
                  className="h-full w-full object-cover hover:scale-105 transition-transform  duration-300   "
                />
              </div>
              <div className="h-full sm:h-72">
                <img
                  src={image30}
                  alt="our story"
                  className="h-full w-full object-cover hover:scale-105 transition-transform  duration-300"
                />
              </div>
              <div className="h-full sm:h-72">
                <img
                  src={imgcontact}
                  alt="our story"
                  className="h-full w-full object-cover hover:scale-105 transition-transform  duration-300"
                />
              </div>
              <div className="h-full sm:h-72">
                <img
                  src={image40}
                  alt="our story"
                  className="h-full w-full object-cover hover:scale-105 transition-transform  duration-300"
                />
              </div>
            </div>
          </div>
          <div className="col-span-12 md:col-span-6">
            <div className="p-3 lg:px-5 space-y-6 flex items-center flex-col justify-center h-full">
              <h1 className=" font-bold text-2xl md:text-3xl my-5 lg:my-4 uppercase text-center">The City’s Most Trusted Contractors</h1>
              <p className="text-sm md:text-base text-[#7a7a7a] text-justify leading-6 "> We are a leading Electrical company in the UAE, known for delivering exceptional technical services. Our reliable, efficient, and budget-friendly solutions make us a preferred service partner across the region. By utilizing prefabrication and modular systems, we ensure high-quality results within short timelines. Megavolt’s team of electrical engineers and technicians, skilled in electrical systems, expertly manage each project phase with precision and care.</p>
              <p className="text-sm md:text-base text-[#7a7a7a] text-justify leading-6">Megavolt has successfully executed multiple electrical & construction projects, consistently designing and completing them to meet the highest safety and quality standards. We provide top-tier electrical services, including installations and technical support, across commercial, industrial, and residential sectors in Dubai. Our longstanding relationships with leading Electrical companies in the region reflect our proven expertise. Megavolt has also completed complex electrical engineering projects and mechanical installations, showcasing our capabilities on an international level.</p>
            </div>
          </div>
        </div>
        <div className="my-10 p-3">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5 ">

            <div className="group">
              <div className="relative flex items-center justify-center p-2 rounded-md border border-gray-500 overflow-hidden">
                <div className="absolute inset-0 bg-brand-gradient transition-all duration-500 transform -translate-x-full group-hover:translate-x-0"></div>
                <div className="relative z-10 flex items-center">
                  <MdMiscellaneousServices className="text-4xl text-primary group-hover:text-white" />
                  <h4 className="ml-3 font-semibold  group-hover:text-white">Best-in Class Materials</h4>
                </div>
              </div>
            </div>

            <div className="group">
              <div className="relative flex items-center justify-center p-2 rounded-md border border-gray-500 overflow-hidden">
                <div className="absolute inset-0 bg-brand-gradient transition-all duration-500 transform -translate-x-full group-hover:translate-x-0"></div>
                <div className="relative z-10 flex items-center">
                  <MdMiscellaneousServices className="text-4xl text-primary group-hover:text-white" />
                  <h4 className="ml-3 font-semibold  group-hover:text-white">Modern Design</h4>
                </div>
              </div>
            </div>

            <div className="group">
              <div className="relative flex items-center justify-center p-2 rounded-md border border-gray-500 overflow-hidden">
                <div className="absolute inset-0 bg-brand-gradient transition-all duration-500 transform -translate-x-full group-hover:translate-x-0"></div>
                <div className="relative z-10 flex items-center">
                  <MdMiscellaneousServices className="text-4xl text-primary group-hover:text-white" />
                  <h4 className="ml-3 font-semibold  group-hover:text-white">Advanced Machinery</h4>
                </div>
              </div>
            </div>

            <div className="group">
              <div className="relative flex items-center justify-center p-2 rounded-md border border-gray-500 overflow-hidden">
                <div className="absolute inset-0 bg-brand-gradient transition-all duration-500 transform -translate-x-full group-hover:translate-x-0"></div>
                <div className="relative z-10 flex items-center">
                  <MdMiscellaneousServices className="text-4xl text-primary group-hover:text-white" />
                  <h4 className="ml-3 font-semibold group-hover:text-white">Experienced Team</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      {/* MEP Contractors  */}

      {/* <div>
        <div className="relative bg-no-repeat	bg-cover overflow-hidden" style={{ backgroundImage: `url(${homebgbanner})` }}>
          <div className="absolute inset-0 bg-black opacity-50"></div>
          <div className="relative text-center py-16 lg:py-24 overflow-hidden" data-aos="zoom-in" data-aos-duration="1500">
            <h1 className="text-[30px] lg:text-[40px] text-white mb-5">Your Trusted MEP Contractors in Dubai
            </h1>
            <p className="text-[#ffffffba] px-3 lg:max-w-[70%] mx-auto text-justify sm:text-center"> As one of Dubai's top MEP contractors, Megavolt is committed to turning your vision into reality. Our team provides exceptional MEP solutions that are both cost-effective and of unmatched quality. Through our expertise and careful project assessment, we guarantee optimal outcomes, ensuring that every aspect of your project is executed to the highest standards.</p>
            <div className="my-8 text-center">
              <Link to="/contactus" className="py-3 px-10 rounded-md bg-orange text-white uppercase inline-block">contact us</Link>
            </div>
          </div>
        </div>
      </div> */}
      <div className="bg-[black] p-3 sm:p-6">
        <div className="grid grid-cols-1 md:grid-cols-12 md:gap-8 text-center items-center">
          <div className="col-span-12 md:col-span-5 flex justify-center">
            <img
              src={image39}
              alt="image"
              height={200}
              width={200}
              className="w-full h-auto object-cover"
            />
          </div>
          <div className="col-span-12 md:col-span-7">
            <div
              className="relative text-center py-4 overflow-hidden"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <h1 className="text-[30px] lg:text-[40px] text-primary mb-5">
                Your Trusted Electrical Contractors in Dubai
              </h1>
              <div className="text-justify text-[#dad1d1] p-2">
                <p className="py-2">
                  As one of Dubai's top Electrical contractors, Megavolt is committed to
                  turning your vision into reality. Our team provides exceptional Electrical
                  solutions that are both cost-effective and of unmatched quality.
                  Through our expertise and careful project assessment, we guarantee
                  optimal outcomes, ensuring that every aspect of your project is
                  executed to the highest standards.
                </p>
                <p className="py-4">
                  At Megavolt, client satisfaction is our priority. We pride
                  ourselves on maintaining open communication, ensuring that your
                  requirements are understood and implemented seamlessly. Our
                  innovative approach to problem-solving and commitment to timely
                  project delivery make us a trusted partner in the industry.
                </p>
              </div>
              <div className="my-8 text-center">
                <Link
                  to="/contactus"
                  className="py-3 px-10 rounded-md bg-brand-gradient text-white shadow-lg hover:shadow-primary/40 hover:scale-105 transition-all uppercase inline-block"
                >
                  contact us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* mep service page design */}
      <div className="lg:py-12 p-3 pb-8">
        <h1 className="font-bold text-2xl md:text-3xl text-center my-8 uppercase">Our Offerings</h1>
        <div className="container mx-auto overflow-hidden">
          <div className="lg:grid-cols-3 grid gap-5 lg:gap-12 grid-cols-1  sm:grid-cols-2">
            {mepServiceData.map((service, index) => (
              <div key={index}
                data-aos="fade-right"
                data-aos-duration="1500"
                data-aos-delay={index * 200}
                className="relative border lg:p-5 p-3 rounded-lg shadow-[4px_6px_10px_-3px_#bfc9d4] group  hover:bg-black overflow-hidden">

                <div className="h-[280px]">
                  <img src={service.image} alt={service.alt} className="h-full w-full" />
                </div>
                <h1 className="text-lg font-bold my-3 text-center group-hover:text-primary">{service.title}</h1>
                <p className="text-sm md:text-base text-[#7a7a7a] text-center leading-6 group-hover:text-white">
                  {service.content}
                </p>

                {/* Overlay and Hover Effect */}
                <div className="absolute inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex items-center flex-col gap-2 justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <p className="text-primary text-lg font-bold">Discover More</p>
                  <div className="flex items-center justify-center">
                    <Link to={service.link} className="text-white text-3xl">{service.icon}</Link>
                  </div>

                </div>
              </div>
            ))}
          </div>
        </div>
      </div>



      {/* <Countingnumber /> */}
      <Countingnumber />
      {/* Featured works */}
      <div className="border bg-[#e5e7eb]">
        <h1 className="font-bold text-2xl md:text-3xl sm:my-8 my-4 uppercase text-center">Featured Works</h1>
        <div className="sm:mb-20 mb-8">
          <Swiper
            pagination={{
              dynamicBullets: true,
            }}
            autoplay={{
              delay: 3000, // Delay between slides in milliseconds
              disableOnInteraction: false, // Keep autoplay even when interacted
            }}
            loop={true} // Loop the slides continuously
            speed={1200} // Adjust for smoothness
            modules={[Pagination, Autoplay]}
            className="mySwiper"
            slidesPerView={1}
            spaceBetween={30}
            breakpoints={{
              640: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 50,
              },
            }}
          >
            {featuredImages.map((src, index) => (
              <SwiperSlide key={index}>
                <div className="w-full h-64">
                  <img className="w-full h-full object-cover" src={src} alt={`featured-${index}`} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>


      {/* our leaders */}
      {/* <Ourleaders /> */}

      <Timeline />

      {/* Scrolling images */}
      <Moving />
      <Contacthome />

    </div>
  );
};

export default Home;
